import { trans } from '@lingoda/i18n';
import { Button } from '../../buttons';
import { Box } from '../Box';
import { Alert } from '../Alert';

export interface Props {
    title: string;
    body: string;
    onDismiss: () => void;
}

export const GuidanceBanner = ({ title, body, onDismiss }: Props) => (
    <Alert severity="promotion" variant="outlined" title={title} icon={false} aria-label={title}>
        <Box mb={2}>{body}</Box>
        <Button
            color="primary"
            variant="contained"
            onClick={onDismiss}
            sx={(theme) => ({
                background: theme.colors.border['progress-bold'],
            })}
        >
            {trans('got-it', {}, 'student-common')}
        </Button>
    </Alert>
);
